import { gql } from 'graphql-request';

export const getAIContentTranslation = gql`
  query getWA_AIContentTranslation($params: WA_AIContentTranslationInput!) {
    wawiAssist {
      getWA_AIContentTranslation(params: $params) {
        content
        languageId
      }
    }
  }
`;
